export default "__VITE_ASSET__DTR2xgBm__"